/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Cookies from 'js-cookie';
import ReactLoading from 'react-loading';
import api from 'api';
import { Header, ClaimHistoryItem, Button, Dialog } from 'components';
import { Container, ContentArea, ContainerHeader, LoadingArea } from './styles';
import { MdChevronLeft } from 'react-icons/md';
import IconButton from '@material-ui/core/IconButton';
import { loadingColor, white } from 'styles/colorProvider';
import moment from 'moment';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import { toast } from 'react-toastify';

function ClaimHistory({ location }) {
  const claimId = parseInt(location.pathname.split('/backoffice/historico-sinistro/')[1]);

  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [claimData, setClaimData] = useState();
  const [loadingCreate, setLoadingCreate] = useState(false);
  const [attendanceAction, setAttendanceAction] = useState();
  const [attendanceData, setAttendanceData] = useState();

  const loadData = async () => {
    setLoading(true);
    const resp = await api({
      method: 'GET',
      url: `claim-history/${claimId}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: Cookies.get('splitrisk-authtoken'),
      },
      json: true,
    });
    setClaimData(resp?.data);
    setLoading(false);
  };

  const handleSubmit = async (e) => {
    setLoadingCreate(true);
    try {
      await api({
        method: 'POST',
        url: `create-claim-history/${claimId}`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: Cookies.get('splitrisk-authtoken'),
        },
        data: {
          description: 'Atendimento registrado',
          details: attendanceData
        },
        json: true,
      });
      setLoadingCreate(false);
      toast.success('Atendimento registrado com sucesso!', {
        position: toast.POSITION.TOP_RIGHT,
        theme: 'colored',
      });
      loadData();
      handleClose();
    } catch (error) {
      toast.error(e?.response?.data?.error, {
        position: toast.POSITION.TOP_RIGHT,
        theme: 'colored',
      });
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  const handleClose = () => {
    setAttendanceData();
    setAttendanceAction();
  };

  const renderDialog = () => (
    <Dialog
      open={attendanceAction}
      requestCancel
      onClose={handleClose}
      title={attendanceAction === 'new' ? 'Novo Atendimento' : attendanceAction === 'view' ? 'Visualizar Atendimento' : ''}
      loading={loading}
      invertButtons
    >
      <div style={{ width: '80%' }}>
        {attendanceAction === 'view' && <p style={{ fontSize: 14 }}>Atendimento realizado por: {attendanceData?.author?.name}</p>}
        {attendanceAction === 'view' && (
          <p style={{ fontSize: 14 }}>
            Atendimento realizado em: {moment(attendanceData?.created_at).format('DD/MM/YYYY HH:mm:ss')}
          </p>
        )}

        <p style={{ fontSize: 14 }}>Descrição do atendimento:</p>
        <TextareaAutosize
          minRows={1}
          onChange={(e) => setAttendanceData(e.target.value)}
          value={attendanceAction === 'new' ? attendanceData : attendanceData?.details}
          placeholder="Insira a descrição do atendimento..."
          disabled={attendanceAction === 'view'}
          style={{
            padding: 10,
            fontFamily: 'Nunito',
            fontSize: 14,
            width: '100%',
            height: '100px',
            borderRadius: 5,
            borderColor: '#d1d2d4',
          }}
        />
        {attendanceAction === 'new' && (
          <Button height="30px" style={{ margin: 0, marginTop: 20 }} disabled={loadingCreate} onClick={handleSubmit}>
            {loadingCreate ? <ReactLoading color={white} height={24} width={24} type="spin" /> : 'Registrar atendimento'}
          </Button>
        )}
        {attendanceAction === 'view' && (
          <Button outlined height="30px" style={{ margin: 0, marginTop: 20 }} onClick={handleClose}>
            Concluir
          </Button>
        )}
      </div>
    </Dialog>
  );

  return (
    <>
      {renderDialog()}
      <Header />
      <Container>
        {loading && (
          <LoadingArea>
            <ReactLoading color={loadingColor} height={40} width={40} type="spin" />
          </LoadingArea>
        )}
        {!loading && (
          <ContentArea>
            <ContainerHeader>
              <h1>
                <IconButton
                  size="small"
                  style={{ marginRight: 10 }}
                  onClick={() => history.push(`/backoffice/detalhes-do-sinistro/${claimId}`)}
                >
                  <MdChevronLeft size={24} />
                </IconButton>
                HISTÓRICO DO SINISTRO
              </h1>
              <Button height="30px" onClick={() => setAttendanceAction('new')}>
                Registrar atendimento
              </Button>
            </ContainerHeader>
            <ClaimHistoryItem data={claimData} setAttendanceData={setAttendanceData} setAttendanceAction={setAttendanceAction} />
          </ContentArea>
        )}
      </Container>
    </>
  );
}

export default ClaimHistory;